import ipAddress from "./ipAddress.js";

module.exports = class ipv4Address extends ipAddress {};



// WEBPACK FOOTER //
// ./frontend/connection_tests/ipv4Address.js